<template>
  <div class="home">
    <el-carousel
        :active="activeIndex"
        :interval="5000"
        :height="imgHeight"
        arrow="never"
        :indicator-position="'outside'"
        @change="handleCarouselChange"
    >
      <el-carousel-item
          v-for="(item, index) in bannerList"
          :key="index"
          style="height: 100%;"
      >
        <a :href="item.url" target="_blank">
          <img
              ref="imgHeight"
              @load="imgLoad"
              :src="item.img"
              alt=""
              style="width: 100%;height: auto"
          />
        </a>
      </el-carousel-item>
    </el-carousel>
    <product class="h-product" />
    <!-- 品质 -->
    <quality class="h-quality" />
    <img style="width:100%;" src="/static/home/banner/bottombanner.png" class="inImg" />
    <div class="b_pic_about">
      {{ $t('main.professionalManufacturerOfOpticalComponents') }}
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import {
  watchScrollDirection
} from "@/helper/utilities.js";
import Product from "./components/product.vue";
import Quality from "./components/quality.vue";
import {
  Carousel,
  CarouselItem
} from "element-ui";
import "element-ui/lib/theme-chalk/carousel.css";
import "element-ui/lib/theme-chalk/carousel-item.css";


import {
  getBlokcList
} from "@/api";
import Cookies from "js-cookie";

export default {
  name: "home",
  components: {
    Product,
    Quality,
    "el-carousel": Carousel,
    "el-carousel-item": CarouselItem
  },
  data() {
    return {
      isCN: true,
      bannerList: [
        // "/static/home/banner/banner1.png",
        // "/static/home/banner/banner2.png",
        // "/static/home/banner/banner3.png"
      ],
      productLayerVisible: true,
      search: "",
      products: [],
      jobCategories: [],
      byteStandards: [],
      byteStandardActiveIndex: 0,
      staffStories: [],
      activeIndex: 0,
      imgHeight: ""
    };
  },
  created() {
    //获取轮播图
    this.getBannerImgList();
  },
  watch: {
    "$store.state.siteInfo": function(newV) {
      this.getBannerImgList();
      this.isCN = this.$i18n.locale === "zn";
    }
  },
  methods: {
    // 获取图片高度
    imgLoad() {
      this.$nextTick(() => {
        this.imgHeight = this.$refs.imgHeight && this.$refs.imgHeight[0].height + "px";
      });
    },
    handleCarouselChange(index) {
      this.activeIndex = index;
    },
    getBannerImgList() {
      var params = {
        "req": {
          "page": 1,
          "where": [{
            "condition": "1",
            "filed": "type",
            "expression": "="
          }, {
            "condition": Cookies.get("siteInfo"),
            "filed": "site_id",
            "expression": "="
          }

          ],
          "limit": 10,
          "order": "orderby desc"
        }
      };

      getBlokcList(params).then(res => {
        if (res.rsp.code === 0) {
          this.bannerList = res.data.list;
        }
      });
    }
  },
  mounted() {
    this.imgLoad();
    window.onresize = () => {
      this.imgLoad();
    };
    const rootVm = this.$root;
    rootVm.$emit(
        "home-scrolling", {
          directionX: 1,
          directionY: -1
        }, {
          x: document.body.scrollLeft,
          y: document.body.scrollTop
        }
    );
    this.unwatch = watchScrollDirection(window, function(...args) {
      rootVm.$emit("home-scrolling", ...args);
    });
  },
  destroyed() {
    this.unwatch();
    window.onresize = null;
  }
};
</script>

<style lang="less" scoped>
.carousel-indicators {
  text-align: right;
  margin-top: -95px;
  position: absolute;
  z-index: 100;
}

.indicator {
  display: inline-block;
  width: 10px;
  height: 6px;
  background-color: #FFFFFF;
  margin: 0 5px;
  cursor: pointer;
}

.indicator.active {
  background-color: #635796;
  width: 20px;
}
.b_pic_about {
  position: relative;
  bottom: 14rem;
  margin-bottom: -5rem;
  font-family: YouSheBiaoTiHei,serif;
  font-size: 3.5rem;
  font-weight: 400;
  font-style: italic;
  color: white;
  text-align: center;
}

::v-deep .el-carousel__indicators--horizontal {
  position: absolute;
  bottom: 70px !important;
  text-align: right;
}

::v-deep .el-carousel__indicators {
  .el-carousel__indicator--horizontal {
    padding: 0;
    margin: 0 0 0 10px;
    background: #fff;
    &:hover {
      .el-carousel__button {
        background: #635796;
      }
    }
    .el-carousel__button {
      width: 20px;
      height: 6px;
      background: #fff;
    }
  }
  .is-active {
    .el-carousel__button {
      width: 30px;
      background: #635796;
    }
  }
}

@keyframes verticalMotion {
  0% {
    transform: translateY(6px);
  }
  50% {
    transform: translateY(-6px);
  }
  100% {
    transform: translateY(6px);
  }
}

@keyframes scrollToRight {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

.home {
  .main {
    width: @main-width;
    margin: auto;
  }
  @media screen and (max-width: 1400px) {
    .h-product,
    .h-quality {
      padding: 0 2%;
    }
    ::v-deep .el-carousel__indicators--horizontal {
      width: 40%;
    }
  }
  @media screen and (min-width: 1400px) {
    .h-product,
    .h-quality {
      padding: 0 10%;
    }
    ::v-deep .el-carousel__indicators--horizontal {
      width: 40%;
    }
  }
  @media screen and (min-width: 1700px) {
    .h-product,
    .h-quality {
      padding: 0 15%;
    }
    ::v-deep .el-carousel__indicators--horizontal {
      width: 35%;
    }
  }
}
</style>